import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useStripeSupport(usdAmount, visitorData, isLoadingVisitorData) {
  const $ = _c(19);
  const t0 = visitorData?.requestId;
  const t1 = visitorData?.visitorId;
  let t2;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== usdAmount) {
    t2 = ["useStripeSupport", usdAmount, t0, t1];
    $[0] = t0;
    $[1] = t1;
    $[2] = usdAmount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== usdAmount || $[5] !== visitorData) {
    t3 = () => anyspendService.checkStripeSupport(usdAmount, visitorData);
    $[4] = usdAmount;
    $[5] = visitorData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isLoadingVisitorData;
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery(t5);
  let t6;
  const t7 = data?.stripeOnramp || false;
  let t8;
  if ($[11] !== data?.stripeWeb2) {
    t8 = data?.stripeWeb2 || {
      isSupport: false
    };
    $[11] = data?.stripeWeb2;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== error || $[14] !== isLoading || $[15] !== refetch || $[16] !== t7 || $[17] !== t8) {
    t9 = {
      stripeOnrampSupport: t7,
      stripeWeb2Support: t8,
      isLoadingStripeSupport: isLoading,
      stripeSupportError: error,
      refetchStripeSupport: refetch
    };
    $[13] = error;
    $[14] = isLoading;
    $[15] = refetch;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  t6 = t9;
  return t6;
}